<template>
    <div>
        <table-actions-menu
            position="table-action-menu--low"
            width="table-action-menu--only-two">

            <edit-button
                :url="route('tenant.clients.licenses.bookings.show', {client: client.id, license: license.id, booking: data.id})" grid="table-action-cell--grid-1of2">
            </edit-button>

            <delete-button
                :url="this.route('tenantapi.bookings.delete', {'client': client.id, 'license': license.id, 'booking': data.id})"
                :confirmTitle="this.trans('bookings.note.deactivate_title')"
                :confirmText="this.trans('bookings.note.deactivate_message')"
                :errorFlashMessage="this.trans('clients.flash.not_deleted')"
                :deleteId="data.id"
                grid="table-action-cell--grid-1of2"
            ></delete-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index', 'client', 'license'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },
    }
</script>
